import API from "../../core/apiConfig";
import { withRowKeys } from "../../core/response";
import type { UserPayload, UserQueryParams } from "./types";

type UserGroup = {
  _id?: string;
  userList?: unknown[];
};

export const getAllUsers = async (params: UserQueryParams) => {
  const response = await API.get("admin/users/all", params).then(
    (res) => res.data,
  );

  if (response.success) return { data: withRowKeys(response.data) };
};

export const getListUserGroup = async (params: UserQueryParams) => {
  const response = await API.get("admin/groups/all", params).then(
    (res) => res.data,
  );

  if (response.success) {
    const groups = (response.data ?? []).map((item: UserGroup) => ({
      ...item,
      countUser: item.userList?.length ?? 0,
    }));
    return { data: withRowKeys(groups) };
  }
};

const postCreateUser = async (data: UserPayload) => {
  const response = await API.post("admin/users", data).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const putUpdateUser = async (data: UserPayload, id: string) => {
  const response = await API.put(`admin/users/${id}`, data).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const deleteUser = async (id: string) => {
  const response = await API.delete(`admin/users/${id}`).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const getMyPermissions = async () => {
  const response = await API.get("/me/permissions").then((res) => res.data);

  if (response.success) return response.data;
};

export default {
  getAllUsers,
  postCreateUser,
  putUpdateUser,
  deleteUser,
  getMyPermissions,
};
